import AccountSync from "../services/AccountSync.js";
import { toEnPageSlug } from "./SlugUtils.js";

/**
 * Propose la création d'un compte au bon moment (28 du TODO) : juste après un
 * record, ou quand une série du Défi du jour commence à compter. Sans compte, la
 * progression ne vit que dans ce navigateur et disparaît avec lui.
 *
 * La carte s'insère sous la carte de score de l'écran de fin, et seulement pour
 * un visiteur non connecté. Le lien d'inscription porte `next` : le joueur
 * revient sur la page de jeu une fois inscrit, sa partie fusionnée au compte.
 */

/** Score minimal pour qu'un record vaille la proposition (pas dès 2 bonnes réponses). */
export const NUDGE_MIN_SCORE = 10;

export function registerUrl() {
    const isEn = window.geoNerdApp.languageManager.currentLang === "en";
    const path = isEn ? `/en/${toEnPageSlug("inscription")}` : "/inscription";
    const next = window.location.pathname + window.location.hash;
    return `${path}?next=${encodeURIComponent(next)}`;
}

/**
 * @param {HTMLElement} container  écran de fin (win/loose/end message)
 * @param {"record"|"streak"} reason
 * @param {object} [vars]          `{ streak }` pour la raison "streak"
 * @param {Element} [before]       insère la carte juste avant cet élément
 */
export function renderAccountNudge(container, reason, vars = {}, before = null) {
    if (!container) return;
    container.querySelector(".account-nudge")?.remove();
    if (AccountSync.isLoggedIn()) return;

    const t = (k) => window.geoNerdApp.languageManager.t(k);
    const body = reason === "streak"
        ? t("nudge.streakBody").replace("{n}", vars.streak ?? "")
        : t("nudge.recordBody");
    const html = `
        <div class="account-nudge" role="note">
            <p class="account-nudge-title">${t(reason === "streak" ? "nudge.streakTitle" : "nudge.recordTitle")}</p>
            <p class="account-nudge-body">${body}</p>
            <a class="btn account-nudge-cta" href="${registerUrl()}">${t("nudge.cta")}</a>
        </div>`;

    if (before) {
        before.insertAdjacentHTML("beforebegin", html);
        return;
    }
    const anchor = container.querySelector(".mode-item") || container.querySelector("p");
    if (anchor) anchor.insertAdjacentHTML("afterend", html);
    else container.insertAdjacentHTML("beforeend", html);
}
